import { Modal } from 'antd';
import { CloseModalIcon } from '@gtintel/platform-atoms';
import PartnerProfile from './components/PartnerProfile';
import PartnerTag from './components/PartnerTag';
import styles from './partnerModal.module.scss';
const PartnerModal = props => {
  const {
    isOpen,
    onCancel,
    partner
  } = props;
  return <Modal className="partner-state-modal" visible={isOpen} footer={null} onCancel={() => onCancel && onCancel()} title="Network Partner Information" closeIcon={<CloseModalIcon />}>
      <div className={styles.container}>
        <PartnerProfile partner={partner} />
        {partner?.tags && <PartnerTag tags={partner?.tags} />}
      </div>
    </Modal>;
};
export default PartnerModal;